module.exports = __webpack_public_path__ + "store/img/SilverTagBase.7f6465f6.svg";